export function numberFormat(val,digit)
{

    if (!val) return '0'
    if(digit ==0)
    {
      let number = (val/1).toFixed(digit).replace('.', ',')
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
    else
    {
      let number = (val/1).toFixed(digit).replace('.', ',')
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
    




    // if (!val) return '0'

    // return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}